import { render, staticRenderFns } from "./fakeData.vue?vue&type=template&id=35a03f4b&scoped=true&"
import script from "./fakeData.vue?vue&type=script&lang=js&"
export * from "./fakeData.vue?vue&type=script&lang=js&"
import style0 from "./fakeData.vue?vue&type=style&index=0&id=35a03f4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a03f4b",
  null
  
)

export default component.exports